'use client';

import { createSlice } from '@reduxjs/toolkit';

export interface TaniState {
  isOpen: boolean;
  url: string;
}

const initialState: TaniState = {
  isOpen: false,
  url: ''
};

const TaniSlice = createSlice({
  name: 'tani',
  initialState,
  reducers: {
    setTaniOpen(state, action) {
      state.isOpen = true;
      state.url = action.payload;
    },
    setTaniClose(state) {
      state.isOpen = false;
      state.url = '';
    }
  },
});

export const { setTaniOpen, setTaniClose } = TaniSlice.actions;
export default TaniSlice.reducer;